/* eslint-disable react/no-array-index-key */

import { makeStyles } from '@mui/styles';
import { Radio } from '@mui/material';
import Skeleton from '@classify/react-core-components/Skeleton';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    margin: spacing(5, 0),
    height: '100%',
  },
  content: {
    maskImage: 'linear-gradient(to bottom, black 30%, transparent 130%)',
    padding: spacing(5),
    border: `1px solid ${palette.layout.surface.border}`,
    borderBottom: 'none',
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
  },
  question: {
    display: 'block',
    height: 32,
    width: '90%',
    marginTop: spacing(2),
  },
  answerWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(2),
  },
  answer: {
    display: 'block',
  },
  skeletonWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    width: '100%',
    borderBottom: `1px solid ${palette.line}`,
    paddingBottom: spacing(1),

    '&:not(:first-of-type)': {
      marginTop: spacing(2),
    },
  },
}));

const QuizSkeleton = () => {
  const classes = useStyles();
  const answerSkeletonsWidth = [150, 150, 100, 70];

  return (
    <div className={classes.root} aria-hidden="true">
      <div className={classes.content}>
        <Typography className={classes.title} variant="h4">
          {translate('quizpage.not_logged.skeleton.question_1')}
        </Typography>
        <div className={classes.skeletonWrapper}>
          <Skeleton classes={{ root: classes.question }} />
          {answerSkeletonsWidth.map((width, index) => (
            <div key={index} className={classes.answerWrapper}>
              <Radio disabled disableFocusRipple />
              <Skeleton classes={{ root: classes.answer }} width={width} height={32} />
            </div>
          ))}
        </div>

        <Typography className={classes.title} variant="h4">
          {translate('quizpage.not_logged.skeleton.question_2')}
        </Typography>
      </div>
    </div>
  );
};

export default QuizSkeleton;
